<div class="task-progress-container">
<div>
  <ng-content></ng-content>
</div>

  <div class="progressbar-container">
    <div class="b-p-container">
      <span class="b-p-textlabel">{{"progress.label"|translate}}</span>
      <div class="b-p-progress">
        <div id="b-progress-bar" [style.width]="task?.progressPercent + '%'" class="b-progress-bar" role="progressbar"></div>
      </div>
      <span id="b-p-label" class="b-p-label">{{task?.progressPercent}}%</span>
      <a href="" *ngIf="canCancel" (click)="onCancelTask();false"> Cancel</a>
    </div>
  </div>
</div>
